export default __webpack_public_path__ + "static/media/trusted-by-ralph.7333051f.png";